import React from 'react';
import {
  messageStatusValue,
  setMessageFilterStatus,
  useChat,
} from '../../../../store/slices/chat';
import { useDispatch } from 'react-redux';

interface props {
  value: string;
  text: string;
}

const ChatFilterItem = ({ text, value }: props) => {
  const { messageStatusFilter } = useChat();
  const dispatch = useDispatch();
  return (
    <div
      className={`filter-item ${
        messageStatusFilter === value
          ? 'bg-light-success text-white'
          : 'bg-soft-background'
      } px-4 py-2 rounded-[8px] border-light-input-border cursor-pointer`}
      onClick={() =>
        dispatch(setMessageFilterStatus(value as messageStatusValue))
      }
    >
      {text}
    </div>
  );
};
export default ChatFilterItem;
